module.exports = __webpack_public_path__ + "media/images/riders/HELEN_GROBERT-891e03e38b2658d544e0b97ac16ed3e0.png";